import React, { useState, useImperativeHandle, forwardRef } from "react";
import ReactDOM from "react-dom";
import "./CofeprisAdHome.css"; 
import { aviso1, aviso2, aviso3, aviso4, aviso5, aviso6 } from "../resources";

const CofeprisAdGalleryHome = forwardRef((_, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [current, setCurrent] = useState(0);
    const [zoomed, setZoomed] = useState(false);
    const [origin, setOrigin] = useState('center center'); 
    const [isDragging, setIsDragging] = useState(false);

    const images = [aviso1, aviso2, aviso3, aviso4, aviso5, aviso6];

    const toggleZoom = (e) => {
        if (!zoomed) {
            const bounds = e.currentTarget.getBoundingClientRect();
            const x = ((e.clientX - bounds.left) / bounds.width) * 100;
            const y = ((e.clientY - bounds.top) / bounds.height) * 100;
            setOrigin(`${x}% ${y}%`);
        }
        setZoomed(prev => !prev);
    };

    const handleMouseDown = () => { if (zoomed) setIsDragging(true); };
    const handleMouseUp = () => { setIsDragging(false); };
    const cursorStyle = zoomed ? (isDragging ? 'grabbing' : 'grab') : 'zoom-in';

    useImperativeHandle(ref, () => ({
        openModal: () => setIsOpen(true)
    }));

    const modal = isOpen ? ReactDOM.createPortal(
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="modal-content-container" onClick={e => e.stopPropagation()}>
                {/* Botón cerrar */}
                <button className="modal-close-button" onClick={() => setIsOpen(false)}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>

                <div 
                    className={`modal-image-wrapper ${zoomed ? "scrollable" : ""}`}
                    onMouseDown={handleMouseDown}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                    onTouchStart={handleMouseDown}
                    onTouchEnd={handleMouseUp}
                    style={{ cursor: cursorStyle }}
                >
                    <img
                        src={images[current]}
                        alt={`Anuncio ${current + 1}`}
                        className={`modal-image ${zoomed ? "zoomed" : ""}`}
                        onClick={toggleZoom}
                        style={{ transformOrigin: origin }} 
                        onContextMenu={e => e.preventDefault()}
                        draggable={false}
                    />
                </div>

                <div className="thumbnails">
                    {images.map((img, i) => (
                        <img
                            key={i}
                            src={img}
                            alt={`thumb-${i}`}
                            className={`thumbnail ${current === i ? "active" : ""}`}
                            onClick={() => setCurrent(i)}
                            onContextMenu={e => e.preventDefault()}
                            draggable={false}
                        />
                    ))}
                </div>
            </div>
        </div>,
        document.body
    ) : null;

    return <>{modal}</>;
});

export default CofeprisAdGalleryHome;
